module.exports = __webpack_public_path__ + "static/media/Hellix-Regular.d85cb389.ttf";